import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { tipoTarjetas, regex } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  constructor(
    private navCtrl: NavController,
    private router: Router,
    private _title: Title
  ) { }

  navigate(){
    this.router.navigate(['/detail'])
  }

  async setNavigation( url: string, param?: string ) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
          type: param
      }
    };
    await this.navCtrl.navigateForward([url], navigationExtras);
  }

  async setNavigationMultipleParams( url: string, queryParams: any ) {
    await this.navCtrl.navigateForward(url, { queryParams });
  }

  async setNavigationRoot( url: string ){
    await this.router.navigate([url]).then( () => {
      window.location.reload();
    });
  }

  public tarjetaSinGuiones( card: string ) {
    const search = '-';
    const replaceWith = '';
    return card.split(search).join(replaceWith);
  }

  public verificarTipoTarjeta( card: string ) {
    let tipoTarjeta;
    const search = '-';
    const replaceWith = '';
    const result = card.split(search).join(replaceWith);

    if ( regex.tarjetasCredito.visa.test( result ) ) {
      tipoTarjeta = tipoTarjetas.visa;
    } else if ( regex.tarjetasCredito.masterCard.test( result ) ) {
      tipoTarjeta = tipoTarjetas.masterCard;
    } else if ( regex.tarjetasCredito.americanExpress.test( result ) ) {
      tipoTarjeta = tipoTarjetas.americanExpress;
    } else {
      tipoTarjeta = 'error';
    }
    return tipoTarjeta;
  }

  public MesTC(month: string, year: string) {
    const value = parseInt(month, 10);
    const currentMonth = new Date().getMonth() + 1;
    const currentYear  = new Date().getFullYear();
    if (value < 0 || value > 12) {
        return false;
    }
    if (year === '') {
        return true;
    }
    year = '20' + year;
    const expYear = parseInt(year, 10);
    return expYear > currentYear || (expYear === currentYear && value >= currentMonth);
  }

  public YearTC(month: string, year: string) {
    year = '20' + year;
    const value = parseInt(year, 10);
    const currentMonth = new Date().getMonth() + 1;
    const currentYear  = new Date().getFullYear();
    if (value < currentYear || value > currentYear + 10) {
        return false;
    }
    if (month === '') {
        return false;
    }
    const expMonth = parseInt(month, 10);
    return value > currentYear || (value === currentYear && expMonth >= currentMonth);
  }

  public validarCVV( card: string, cvv: string ) {
    let result = false;
    if ( card !== undefined && cvv !== undefined ) {
      const tipo = this.verificarTipoTarjeta( card );
      if ( tipo === 'error' ) {
        return result;
      }

      if ( tipo === tipoTarjetas.americanExpress ) {
        if ( regex.tarjetasCredito.cvvAmericanExpress.test( cvv ) ) {
          result = true;
        }
      } else {
        if ( regex.tarjetasCredito.cvv.test( cvv ) ) {
          result = true;
        }
      }
    }
    return result;
  }

  set(titles: string | string[]) {
    if (Array.isArray(titles)) {
      titles = titles.join(' - ');
    }
    if (titles) this._title.setTitle(titles);
  }

}
